export default __webpack_public_path__ + "static/media/HLTHTEK_ABDM_DEMO.2540791b.mp4";